<div class="position-relative">
    <h1>Nicht konfigurierte Ladestationen</h1>
    <mat-icon class="help-icon" #helpIcon>help</mat-icon>

    <app-help-box [helpIcon]="helpIcon._elementRef" key="UNKNOWN_CPI">
        Hier können OCPP Ladestation unterstützt eingerichtet werden.<br>
        Für die unterstütze Einrichtung muss zunächst die Station nach Herstelleranleitung eingerichtet werden.
        Als Option OCPP Prefix muss gesetzt werden: <b>ws{{secure ? 's' : ''}}://{{host}}/ocppj/{{fleetId | async}}/</b><br>
        Für die CPI (Charge Point Identity) kann ein beliebiger alphanumerischer Name (Zahlen und Buchstaben)
        gesetzt werden. Die CPI muss innerhalb der Flotte einzigartig sein.<br>
        Anschließend werden die Station automatisch in der unten stehenden Liste aufgelistet und
        können geführt in das IO-ELON System integriert werden.
    </app-help-box>

    <div *ngIf="(unknownCpis | async) as unknownCpis">
        <app-unknown-cpi-table [unknownCpis]="unknownCpis"></app-unknown-cpi-table>
    </div>
</div>
